import ActivityMenu from "@/components/elements/activityFeed/menus/ActivityMenu";
import { IContentTitleProps } from "@/interfaces/activityFeed";
import "../../../../../css/activityFeed/elements/content-title.scss";



const ContentTitle = ({zIndexNum, contentTitle, className, onLikeClick, isLiked = false, onReplyClick, getWebLink, onDeleteClick, onDownloadReportClick, onArchiveContentClick, onApproveContentClick, onDownloadCSVClick, userPageLink, showMenu = true, isItalic}: IContentTitleProps) => {

    return (
        <div className={`content-title-wrapper ${className ?? ""}`} style={zIndexNum !== undefined ? { zIndex: zIndexNum } : undefined}>
            <span className={`content-title ${isItalic ? "italic" : ""}`}>{contentTitle}</span>

            {showMenu && 
                <ActivityMenu
                    onLikeClick={onLikeClick}
                    isLiked={isLiked}
                    onArchiveContentClick={onArchiveContentClick}
                    onDeleteClick={onDeleteClick}
                    onDownloadReportClick={onDownloadReportClick}
                    getWebLink={getWebLink}
                    onReplyClick={onReplyClick}
                    onApproveContentClick={onApproveContentClick}
                    onDownloadCSVClick={onDownloadCSVClick}
                    userPageLink={userPageLink}
                />
            }
        </div>
    );
};

export default ContentTitle